document.addEventListener('Loxa:productAndInsuranceAddedToCart', handleLoxaEvent);
document.addEventListener('Loxa:productAddedToCart', handleLoxaEvent);

function handleLoxaEvent(event) {
  const atcButton = document.querySelector('button[name="add"]');

  if (atcButton) {
    Loxa.preventClickInterception = true;
    atcButton.click();
    Loxa.log('Add to Cart button clicked');
  } else {
    Loxa.log('Add to Cart button not found');
  }
}
